import { CaregiverDto, Config } from '@ecdlink/core';
import { CaregiverInput, CaregiverClients } from '@ecdlink/graphql';
import { api } from '../axios.helper';
import { MergedCaregiver } from '@/store/caregiver/caregiver.types';
class CaregiverService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getCaregiversForHealthCareWorker(): Promise<CaregiverDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'getAllCaregiversForHealthCareWorker',
    });

    if (response.status !== 200) {
      throw new Error('Getting Caregivers failed - Server connection error');
    }

    return response.data.data.allCaregiversForHealthCareWorker;
  }

  async updateCareGiver(
    id: string,
    input: CaregiverInput
  ): Promise<CaregiverDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateCaregiver',
      variables: {
        id: id,
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating caregiver failed - Server connection error');
    }

    return response.data.data.updateCaregiver;
  }

  async createCaregiver(input: CaregiverInput): Promise<CaregiverDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'createCaregiver',
      variables: {
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Create caregiver failed - Server connection error');
    }

    return response.data.data.createCaregiver;
  }

  async getCaregiverClients(caregiverId: string): Promise<CaregiverClients> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { caregiverClients: CaregiverClients };
      errors?: {};
    }>(``, {
      id: 'GetCaregiverClients',
      variables: {
        caregiverId,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error('Get Get Caregiver Clients - Server connection error');
    }

    return response.data.data.caregiverClients;
  }

  async getAllCaregiverClients(
    recordsPerPage?: number,
    pageNumber?: number
  ): Promise<MergedCaregiver[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { allCaregiversForHCW: MergedCaregiver[] };
      errors?: {};
    }>(``, {
      id: 'GetAllCaregiversForHCW',
      variables: {
        recordsPerPage,
        pageNumber,
      },
    });

    if (response.status !== 200 || response.data.errors) {
      throw new Error('Get Get Caregiver Clients - Server connection error');
    }

    return response.data.data.allCaregiversForHCW;
  }
}

export default CaregiverService;
